import { AxiosInstance } from 'axios';
import { WorkplacesRepository } from '@/model/repository/shift/WorkplacesRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): WorkplacesRepository => ({
    index() {
      return Repository.get(`${resource}`, { data: { errorHandle: false } });
    },
  });
